import { Link } from 'react-router-dom';

export default function QuizCTA() {
  return (
    <div className="rounded-2xl p-8 text-center gradient-cta">
      <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-3">
        For couples
      </p>
      <h2 className="text-2xl font-extrabold text-white mb-3">
        Curious what you're both into?
      </h2>
      <p className="text-white/80 mb-6 text-sm leading-relaxed">
        Take our anonymous quiz — only see what you both say yes to.
      </p>
      <Link
        to="/start"
        className="inline-block bg-white text-primary font-extrabold px-8 py-3 rounded-xl hover:bg-white/90 transition-colors"
      >
        Take the Quiz 🔥
      </Link>
    </div>
  );
}
